import { createSlice } from "@reduxjs/toolkit";
import { fetchQuickActionList } from "./thunk";

interface QuickActionsState {
  // List data
  quickActionList: any[];
  totalRecords: number;
  listLoading: boolean;
  listError: string | null;
}

const initialState: QuickActionsState = {
  quickActionList: [],
  totalRecords: 0,
  listLoading: false,
  listError: null,
};

const quickActionsSlice = createSlice({
  name: "quickActions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // List thunks
      .addCase(fetchQuickActionList.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchQuickActionList.fulfilled, (state, action) => {
        state.listLoading = false;
        state.quickActionList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchQuickActionList.rejected, (state, action) => {
        state.listLoading = false;
        state.listError =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch quick action list";
        state.quickActionList = [];
        state.totalRecords = 0;
      });
  },
});

export default quickActionsSlice.reducer;

